'use client';

import { Transition, Typography } from 'components';
import { ContextLibraryClipArt } from 'lib/svgs/ClipArts';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/navigation';
import UploaderContext from './_components/UploaderContext';
import { useContextLibraryContext } from './_context/ContextLibraryContext';

export default function ContextLibraryPage() {
  const t = useTranslations();
  const router = useRouter();
  const { refetch, hasNodes, isChecking, defaultTags } = useContextLibraryContext();

  const handleRefetch = async () => {
    await refetch();
    router.push('/smart-tasks/context-library/list');
  };

  if (!!hasNodes && !isChecking) return null;

  return (
    <div className="flex h-full flex-1 flex-col items-center justify-center">
      <Transition className="mb-14 flex h-24 justify-center">
        <ContextLibraryClipArt className="h-[170px] w-[170px]" />
      </Transition>
      <Transition delay={0.4}>
        <div className="mb-6 mt-12">
          <Typography variant="medium7xl" className="!mt-0 flex justify-center text-tertiary-100">
            {t('context_library.intro.title')}
          </Typography>
        </div>
        <div className="mb-12 max-w-3xl">
          <Typography variant="light3" className="m-0 !leading-7 text-tertiary-200">
            <div className="text-center">{t('context_library.intro.paragraph.one')}</div>
          </Typography>
        </div>
      </Transition>
      <Transition delay={1} className="flex">
        <UploaderContext defaultTags={defaultTags} refetch={handleRefetch} />
      </Transition>
    </div>
  );
}
